import DeskTopVue from './desktop.vue';
import MobileVue from './mobile.vue';
import { isMobile } from '@zoom/billing-responsive';

export default isMobile ? MobileVue : DeskTopVue
